<div class="spinner_block" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>

<div class="addModal_content" *ngIf="addTable">
  <div class="addModal_block">
    <i class="fas fa-times" (click)="addTable = false"></i>
    <form class="addForm" [formGroup]="tarifsAddForm">
      <input
        class="addtable"
        type="text"
        placeholder="Имя"
        formControlName="name"
      />
      <input
        class="addtable"
        type="number"
        placeholder="Цена"
        formControlName="price"
      />
      <input
        class="addtable"
        type="number"
        placeholder="Счёт"
        formControlName="score"
      />
      <input
        class="addtable"
        type="number"
        placeholder="Скорость"
        formControlName="speed"
      />
      <input
        class="addtable"
        type="text"
        placeholder="Комментарий"
        formControlName="comment"
      />
      <div class="addFormCheckbox_block">
        <input
          class="addtable"
          type="checkbox"
          placeholder="mobile_vis"
          formControlName="mobile_vis"
        />
        <p>Мобильный вид</p>
      </div>
      <div class="addFormCheckbox_block">
        <input
          class="addtable"
          type="checkbox"
          placeholder="with_change_speed"
          formControlName="with_change_speed"
        />
        <p>С изменением скорости</p>
      </div>
      <button
        class="addButton"
        [disabled]="tarifsAddForm.invalid"
        [ngStyle]="{ opacity: tarifsAddForm.invalid ? '.6' : '1' }"
        (click)="addNewTable()"
      >
        OK
      </button>
    </form>
  </div>
</div>

<div class="editModal_content" *ngIf="editTable">
  <div class="editModal_block">
    <i class="fas fa-times" (click)="editTable = false"></i>
    <form class="editForm" [formGroup]="tarifsEditForm">
      <input
        class="editTable"
        type="text"
        placeholder="Имя"
        formControlName="name"
      />
      <input
        class="editTable"
        type="number"
        placeholder="Цена"
        formControlName="price"
      />
      <input
        class="editTable"
        type="number"
        placeholder="Счёт"
        formControlName="score"
      />
      <input
        class="editTable"
        type="number"
        placeholder="Скорость"
        formControlName="speed"
      />
      <input
        class="editTable"
        type="text"
        placeholder="Комментарий"
        formControlName="comment"
      />
      <div class="addFormCheckbox_block">
        <input
          class="addtable"
          type="checkbox"
          placeholder="mobile_vis"
          formControlName="mobile_vis"
        />
        <p>Мобильный вид</p>
      </div>
      <div class="addFormCheckbox_block">
        <input
          class="addtable"
          type="checkbox"
          placeholder="with_change_speed"
          formControlName="with_change_speed"
        />
        <p>С изменением скорости</p>
      </div>
      <button
        class="editButton"
        [disabled]="tarifsEditForm.invalid"
        [ngStyle]="{ opacity: tarifsEditForm.invalid ? '0.6' : '1' }"
        (click)="editNewTable()"
      >
        ОК
      </button>
    </form>
  </div>
</div>
<!-- hour : 23
id : 1
minute : 0
radius_profile : "tamosho+5-night"
speed : 10240
tarif_id : 2047 -->
<div class="editModali_content" *ngIf="openChangeModal">
  <div class="editModal_block">
    <div class="addTarifChangeModal_block" *ngIf="openPostChangeModal">
      <div class="addTarifChangeModal_item">
        <i class="fas fa-times iconCloseItem" (click)="openPostChangeModal = false"></i>
        <form class="editForm" [formGroup]="tarifsSpeedAddForm">
        <input
          class="editTable"
          type="number"
          placeholder="Час"
          formControlName="hour"
        />
        <input
          class="editTable"
          type="number"
          placeholder="Минут"
          formControlName="minute"
        />
        <input
          class="editTable"
          type="text"
          placeholder="Radius профиль"
          formControlName="radius_profile"
        />
        <input
          class="editTable"
          type="number"
          placeholder="Скорость"
          formControlName="speed"
        />
        <select name="" id="" formControlName="tarif_id" >
          <option *ngFor="let tarifs of tarifsData" [value]="tarifs.id" >{{tarifs.name}}</option>
        </select>

        <button
          class="editButton"
          [disabled]="tarifsSpeedAddForm.invalid"
          [ngStyle]="{ opacity: tarifsSpeedAddForm.invalid ? '0.6' : '1' }"
          (click)="addchangeTarif()"
        >
          ОК
        </button>
      </form>
      </div>
    </div>
    <div class="addTarifChangeModal_block" *ngIf="openPutChangeModal">
      <div class="addTarifChangeModal_item">
        <i class="fas fa-times iconCloseItem" (click)="openPutChangeModal = false"></i>
        <form class="editForm" [formGroup]="tarifsSpeedEditForm">
        <input
          class="editTable"
          type="number"
          placeholder="Час"
          formControlName="hour"
        />
        <input
          class="editTable"
          type="number"
          placeholder="Минут"
          formControlName="minute"
        />
        <input
          class="editTable"
          type="text"
          placeholder="Radius профиль"
          formControlName="radius_profile"
        />
        <input
          class="editTable"
          type="number"
          placeholder="Скорость"
          formControlName="speed"
        />
        <select name="" id="" formControlName="tarif_id" >
          <option *ngFor="let tarifs of tarifsData" [value]="tarifs.id" >{{tarifs.name}}</option>
        </select>

        <button
          class="editButton"
          [disabled]="tarifsSpeedEditForm.invalid"
          [ngStyle]="{ opacity: tarifsSpeedEditForm.invalid ? '0.6' : '1' }"
          (click)="editchangeTarif()"
        >
          ОК
        </button>
      </form>
      </div>
    </div>
    <div class="title_block">
      <button (click)="openPostChangeTarifModal()" *ngIf="permitActions">Добавить</button>
    </div>
    <i class="fas fa-times iconClose" (click)="openChangeModal = false"></i>
    <div class="table_container">
      <table class="resp-tab">
        <thead>
          <tr>
            <th>id</th>
            <th>tarif id</th>
            <th>Час</th>
            <th>Минут</th>
            <th>Скорость</th>
            <th>Radius профиль</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tarifEditSpeed">
            <td>
              <span>ID</span>
              <h1>{{ item.id }}</h1>
            </td>
            <td>
              <span>tarif id</span>
              <h1>{{ item.tarif_id }}</h1>
            </td>
            <td>
              <span>Час</span>
              <h1>{{ item.hour }}</h1>
            </td>
            <td>
              <span>Минут</span>
              <h1>{{ item.minute }}</h1>
            </td>
            <td>
              <span>Скорость</span>
              <h1>{{ item.speed }}</h1>
            </td>
            <td>
              <span>Radius профиль</span>
              <h1>{{ item.radius_profile }}</h1>
            </td>
            <td *ngIf="permitActions">
              <span>Действия</span>
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with a menu"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openEditChangeTarifModal(item.id)">
                  <mat-icon>edit</mat-icon>
                  <span>Изменить</span>
                </button>

                <button mat-menu-item (click)="deletechangeTarif(item.id)">
                  <mat-icon>delete</mat-icon>
                  <span>Удалить</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="devide_block">
  <app-header></app-header>
  <div class="container">
    <div class="container_content">
      <div class="title_block">
        <h1>Тарифы</h1>
        <button (click)="openAddTable()" *ngIf="permitActions">Добавить</button>
      </div>

      <div class="filter_content">
        <form class="filter_form" [formGroup]="tarifsFilterForm">
          <div class="filter_block">
            <input type="text" placeholder="Имя" formControlName="name" />
            <input type="number" placeholder="Цена" formControlName="price" />
            <input type="number" placeholder="Счёт" formControlName="score" />
            <input
              type="number"
              placeholder="Скорость"
              formControlName="speed"
            />
            <input
              type="text"
              placeholder="Комментарий"
              formControlName="comment"
            />
            <button (click)="filterTable()">ОК</button>
          </div>

          <!-- <div class="pagination_block">
            <input type="number" placeholder="0">
          </div> -->
        </form>
      </div>

      <div class="table_container">
        <table class="resp-tab">
          <thead>
            <tr>
              <th>ID</th>
              <th>Имя</th>
              <th>Цена</th>
              <th>Счёт</th>
              <th>Скорость</th>
              <th>Комментарий</th>
              <th>Мобильный вид</th>
              <th>С изменением скорости</th>
              <th *ngIf="permitActions">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle class="c1" cx="10" cy="10" r="9.5" stroke="black" />
                  <circle class="c2" cx="10" cy="10" r="3" fill="black" />
                </svg>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tarifs of tarifsData" [formGroup]="tarifsEditForm">
              <td>
                <span>ID</span>
                <h1>{{ tarifs.id }}</h1>
              </td>

              <td>
                <span>Имя</span>
                <h1>{{ tarifs.name }}</h1>
              </td>

              <td>
                <span>Цена</span>
                <h1>{{ tarifs.price }}</h1>
              </td>

              <td>
                <span>Счёт</span>
                <h1>{{ tarifs.score }}</h1>
              </td>

              <td>
                <span>Скорость</span>
                <h1>{{ tarifs.speed }}</h1>
              </td>

              <td>
                <span>Комментарий</span>
                <h1>{{ tarifs.comment }}</h1>
              </td>
              <td>
                <span>Мобильный вид</span>
                <h1>{{ tarifs.mobile_vis }}</h1>
              </td>
              <td>
                <span>C изменением скорости</span>
                <h1>{{ tarifs.with_change_speed }}</h1>
              </td>

              <td *ngIf="permitActions">
                <span>Действия</span>
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  aria-label="Example icon-button with a menu"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openEditTable(tarifs.id)">
                    <mat-icon>edit</mat-icon>
                    <span>Изменить</span>
                  </button>
                  <button mat-menu-item (click)="openGetChangeTarifModal()">
                    <mat-icon>add_to_queue</mat-icon>
                    <span>Тамошо +</span>
                  </button>

                  <button mat-menu-item (click)="deleteTable(tarifs.id)">
                    <mat-icon>delete</mat-icon>
                    <span>Удалить</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination_block">
        <pagination-controls
          nextLabel="Далее"
          previousLabel="Назад"
          (pageChange)="page = $event"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>
